export const GET_COMPANIES = Symbol('GET_COMPANIES');
export const GET_COMPANIES_REQUEST = Symbol('GET_COMPANIES_REQUEST');
export const GET_COMPANIES_SUCCESS = Symbol('GET_COMPANIES_SUCCESS');
export const GET_COMPANIES_ERROR = Symbol('GET_COMPANIES_ERROR');
